<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <router-link :style="inputStyle" :to="pageNo"> 点击填写 </router-link>
  </div>
</template>

<script>
import _ from 'lodash'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'

export default {
  name: 'jtRedirectPage',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    pageName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      type: this.maxLength >= 100 ? 'textarea' : 'text',
      rows: this.maxLength > 200 ? 8 : 5,
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
        color: this.editable ? '#25a4bb' : '#909399 ',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  computed: {
    pageNo() {
      const { pageInfo } = storage.getItem(constants.GLOBAL_CONFIG)
      let obj = _.find(pageInfo, { pageTitle: this.pageName })
      return '/page/' + obj.pageId
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
}
</script>

<style lang="stylus">
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.component-container .is-disabled .el-input__inner {
  color: #666666;
}

.xing {
  color: #fff;
  margin-right: 5px;
}
</style>
